import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-0e1df729")
const _hoisted_1 = { class: "multiline-field" }
const _hoisted_2 = ["value"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("textarea", {
      ref: "textareaRef",
      rows: "1",
      value: _ctx.inputVal,
      style: _normalizeStyle(_ctx.styles),
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args)))
    }, null, 44, _hoisted_2),
    _withDirectives(_createElementVNode("span", { class: "placeholder" }, _toDisplayString(_ctx.placeholder), 513), [
      [_vShow, _ctx.inputVal.length === 0]
    ])
  ]))
}